import React, { type PropsWithChildren } from 'react';

import { BasicInput } from '../BasicInput/BasicInput';
import { RootWrapper } from '../RootWrapper';
import type { TextInputProps } from '../types';

import { useBasicTextInputProps } from './useBasicTextInputProps';

/**
 * Provides a text input with optional embedded slot content.
 */
export const TextInput = React.forwardRef<
  HTMLInputElement,
  PropsWithChildren<TextInputProps>
>(({ children, ...props }, ref) => {
  const { basicInputProps } = useBasicTextInputProps(props);

  return (
    <RootWrapper {...props}>
      <BasicInput ref={ref} {...basicInputProps} data-testid="text-input" />
      {children}
    </RootWrapper>
  );
});
TextInput.displayName = 'TextInput';
